import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function Comparison() {
  return <section className="py-24 px-4 bg-[#F0F2EB]" data-id="element-67" data-mp="1g5yk5o8tdr5m">
      <div className="max-w-5xl mx-auto" data-id="element-68" data-mp="1l6m63vi6rhsz">
        <div className="text-center mb-16" data-id="element-69" data-mp="1l5kspkdp6j83">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-4" data-id="element-70" data-mp="1pz5vrqu5e3e5">
            La diferencia es concreta
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-71" data-mp="1uzjs4bmdzowc">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl border-t-4 border-terracota shadow-sm" data-id="element-72" data-mp="1zuz4ez4qxcqn">
            <h3 className="text-xl font-bold text-terracota mb-6 text-center" data-id="element-73" data-mp="eipa3fs02qiu">
              SIN EL MEGA PACK
            </h3>
            <ul className="space-y-4" data-id="element-74" data-mp="1m1qz9dv8zsd3">
              {['Información dispersa en múltiples fuentes', 'Clases improvisadas o preparadas de apuro', 'Temas aislados sin conexión visible', 'Actividades que hay que crear desde cero', 'Evaluaciones armadas la noche anterior', 'Proyectos incompletos o sin base técnica', 'Fines de semana planificando'].map((item, i) => <li key={i} className="flex items-start gap-3 text-ink text-sm" data-id="element-75" data-mp="20z18shobyo66" data-mpi={i}>
                  <XCircle size={18} className="text-terracota/60 shrink-0 mt-0.5" data-id="element-76" data-mp="1vydijy7xebd0" />
                  <span data-id="element-77" data-mp="1qzab674h3t1v">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-8 rounded-2xl border-t-4 border-green shadow-lg relative" data-id="element-78" data-mp="khn822wgyxdl">
            <div className="absolute -top-3 right-4 bg-gold text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-79" data-mp="czysty6d8flv">
              TU NUEVA REALIDAD
            </div>
            <h3 className="text-xl font-bold text-green mb-6 text-center" data-id="element-80" data-mp="3ufdw2youvmzd">
              CON EL MEGA PACK
            </h3>
            <ul className="space-y-4" data-id="element-81" data-mp="3lg0okbkal8ha">
              {['Contenidos organizados en un sistema lógico', 'Clases estructuradas y listas para dar', 'Proceso completo de la materia prima al mercado', 'paquete de actividades listas para usar', 'Banco de evaluaciones completo por unidad', 'Proyectos productivos reales con formulaciones y costos', 'Fines de semana para vos'].map((item, i) => <li key={i} className="flex items-start gap-3 text-ink text-sm font-medium" data-id="element-82" data-mp="2rwkmjrl2l3h2" data-mpi={i}>
                  <CheckCircle2 size={18} className="text-green shrink-0 mt-0.5" data-id="element-83" data-mp="36umsu9jhk320" />
                  <span data-id="element-84" data-mp="3ftqf1mdy8ykq">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 border border-gold/30 shadow-sm text-center max-w-3xl mx-auto" data-id="element-85" data-mp="3atvmleej00xk">
          <h3 className="text-2xl font-serif font-bold text-green mb-2" data-id="element-86" data-mp="3pj9xiqxr2qf2">
            Un año de Industrialización de Alimentos. Organizado. Listo. Desde
            hoy.
          </h3>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-6 mb-8 text-sm text-ink" data-id="element-87" data-mp="2g52c1bxxeto">
            <span className="flex items-center gap-1" data-id="element-88" data-mp="3uk7cyvrdl6cv">
              <span className="text-green font-bold" data-id="element-89" data-mp="1rw8wd09oon1z">✓</span> 5 tomos completos
            </span>
            <span className="flex items-center gap-1" data-id="element-90" data-mp="1wvbyabudad5q">
              <span className="text-green font-bold" data-id="element-91" data-mp="1wtr62sviz6b1">✓</span> paquete de
              actividades
            </span>
            <span className="flex items-center gap-1" data-id="element-92" data-mp="21o54l45hhtjx">
              <span className="text-green font-bold" data-id="element-93" data-mp="26lesugh4zz66">✓</span> Evaluaciones
            </span>
            <span className="flex items-center gap-1" data-id="element-94" data-mp="18y69os4lz27c">
              <span className="text-green font-bold" data-id="element-95" data-mp="18zhacj2rbtu8">✓</span> 5 bonos
            </span>
            <span className="flex items-center gap-1" data-id="element-96" data-mp="1dwpwsvuxuk1a">
              <span className="text-green font-bold" data-id="element-97" data-mp="1ivaxsxi0l7qs">✓</span> Proyectos
            </span>
          </div>

          <div className="mb-8" data-id="element-98" data-mp="1mxe9nn8liecl">
            <p className="text-5xl font-bold text-green mb-2" data-id="element-99" data-mp="1myh3o417swwq">USD 19,90</p>
            <p className="text-sm text-terracota font-medium" data-id="element-100" data-mp="2u9xy0n4w3vu1">
              Precio promocional disponible por tiempo limitado
            </p>
          </div>

          <Button href="#pricing" variant="terracota" className="mb-4" data-id="element-101" data-mp="moprlavwcyus">
            QUIERO MI MEGA PACK AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-xs text-slate font-medium" data-id="element-102" data-mp="iofap36kgo15">
            <span data-id="element-103" data-mp="dvumch6fj350">🔒 Pago seguro</span>
            <span data-id="element-104" data-mp="dut49sqzxgds">⚡ Acceso inmediato</span>
            <span data-id="element-105" data-mp="8y2rpfeeh2x4">💱 Pagás en tu moneda local</span>
            <span data-id="element-106" data-mp="8xaww6smn97w">🛡️ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}